import gql from 'graphql-tag';

export default gql`
  mutation sendPass($pass: String!) {
    sendPass(pass: $pass) 
  }
`;
